import React from 'react';
import { useTranslation } from 'react-i18next';
import image from './barcode-example.svg';
import './UrpassTicketView.css';
import { IonIcon } from '@ionic/react';
import { datesFormatTimeDate, datesFromString } from '../../utils/dates';
import { UrpassTicketType } from '../../services/types/urpassapitypes';

type UrpassTicketViewProps = {
  ticket: UrpassTicketType;
  owner?: string | undefined;
};
export default function UrpassTicketView({
  ticket,
  owner,
}: UrpassTicketViewProps) {
  const [t] = useTranslation('global');

  return (
    <div className="urpass-ticket-view">
      <h1 className="h1 pb-2 h1plus ion-text-center">{t('urpassview.validity_warning')}</h1>
      <div className="ticket-details-container">
        <h1 className="h1 pb-2 ion-text-center title">{ticket.name}</h1>
        <IonIcon
          icon={'assets/urpass/' + ticket.urpassTenantId + '.svg'}
          className="urpass-select-icon"
        />
        <h1 className="h1 pb-2 ion-text-center">
          {t('urpassview.valid')}:{' '}
          {datesFormatTimeDate(datesFromString(ticket.validTo))}
        </h1>
        <h1 className="h1 pb-2 ion-text-center">
          <span className="h1notbold">{t('urpassview.ticketid')}:</span>{' '}
          {ticket.inspectionCode}
        </h1>
        <h1 className="h1 pt-2 ion-text-center owner">
          <span className="h1notbold">{t('urpassview.owner')}:</span> <span className='no-translate'>{owner}</span>
        </h1>
      </div>

      <h1 className="h1 h1plus pb-2 ion-text-center">{t('urpassview.scan')}</h1>
      <a href={t('urpassview.helpurl')!} rel={'noreferrer'} target={'_blank'}>
        <IonIcon
          className="icon-question"
          src={'assets/icon/question.svg'}
        ></IonIcon>
        {t('urpassview.faqs')}
      </a>
    </div>
  );
}
